export default {"src":"/_next/static/media/KHC.132af49c.svg","height":18,"width":18};